import { createFileRoute, Outlet, Link } from "@tanstack/react-router";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { IoPersonCircle } from "react-icons/io5";
import { useAuth } from "@/providers/authProvider";
import { toast } from 'react-toastify';
import {queryClient} from "@/main";
import { SidebarProvider } from "@/providers/SidebarProvider";
import { useSidebar } from "@/providers/useSidebar";

function LayoutInner() {
  const { isAuthenticated } = useAuth();
  const { sidebar } = useSidebar();
  const handleSignOutClick = () => {
    queryClient.clear(); // キャッシュをクリア
    toast.success("ログアウトしました", {
      position: "bottom-left",
    });
  };
  return (
    <div className="flex h-screen w-screen bg-slate-50">
      {sidebar}
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        <header className="w-full h-[80px] shrink-0">
          <div className="flex items-center justify-end h-full max-w-screen-2xl mx-auto p-4">
            <div>
              <ul className="flex items-center justify-end space-x-4">
                <li>
                  <a
                    href="https://share.hsforms.com/1ggRKeK26ShKTrjN_zGOEbw2mtef"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:opacity-80"
                  >
                    <AiOutlineQuestionCircle size={30} />
                  </a>
                </li>
                {isAuthenticated && (
                <li>
                  <Link
                    to="/profile"
                    className="hover:opacity-80"
                  >
                    <IoPersonCircle size={32} />
                  </Link>
                </li>
                )}
                {isAuthenticated ? (
                  <li>
                    <Link to="/signout" onClick={handleSignOutClick}>サインアウト</Link>
                  </li>
                ) : (
                  <li>
                    <Link to="/signin">サインイン</Link>
                  </li>
                )}
                <li></li>
              </ul>
            </div>
          </div>
          <div className="w-full border border-b-slate-100"></div>
        </header>
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

const LayoutComponent = () => {
  return (
    <SidebarProvider>
      <LayoutInner />
    </SidebarProvider>
  );
};

export const Route = createFileRoute("/_layout")({
  component: LayoutComponent,
});
